// src/lib/briefFormat.js
//
// Date and status helpers for the advisor case brief. Moved unchanged out of
// CaseBriefPage.js (ticket 072); one definition shared by the page and the brief parts.

export function formatDate(d)     { if (!d) return '—'; return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }
export function formatDateTime(d) { if (!d) return '—'; return new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) }
export function formatMoveDate(d) { if (!d) return '—'; return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) }
export function statusLabel(s)    { return { new: 'New', contacted: 'Contacted', converted: 'Converted', not_a_fit: 'Not a fit' }[s] || s }

// 1st, 2nd, 3rd, 4th ... (the "{n}th save" line of an intake brief)
export function ordinal(n) {
  const v = n % 100
  if (v >= 11 && v <= 13) return `${n}th`
  return `${n}${{ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th'}`
}
